import { useCallback } from "react";
import { PanelHeader } from "../../../../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../../../../components/Panel/PanelFooter";
import { UsePanelUbicacionCrear } from "./UsePanelUbicacionCrear";
import { IOpenPanel } from "../../../../../../Interfaces/IPanel";
import { IUbicacionRequest } from "../../../../../../Interfaces/auxiliar/IUbicacion";
import { IComboBox, IComboBoxOption, Panel, TextField } from "@fluentui/react";
import { ComboBoxIDS } from "../../../../../../components/generic/ComboBoxIDS";
import { UseComboNivel } from "../../../../../../hooks/auxiliar/combo/UseComboNivel";
import { UseComboUbicacion } from "../../../../../../hooks/auxiliar/combo/UseComboUbicacion";
import { MessageBarResponse } from "../../../../../../components/MessageBarResponse/MessageBarResponse";
import { ProgressBarLoading } from "../../../../../../components/ProgressBarLoading/ProgressBarLoading";

export interface IPanelUbicacion extends IOpenPanel {
    filtro: IUbicacionRequest
    setFiltro: React.Dispatch<React.SetStateAction<IUbicacionRequest>>
    nivel?: number
    comboDescripcion?: string
    comboNivel?: number
    descripcion?: string;
}

const PanelUbicacionCrear = (props: IPanelUbicacion) => {
    const { dataComboNivel, onClickComboNivel, comboBoxRefNivel } = UseComboNivel()
    const { dataComboUbicacion, onClickComboUbicacion, _onkeyUpSearchUbicacion, comboBoxRefUbicacion } = UseComboUbicacion({ comboNivel: props.comboNivel ?? 0, isOpen: props.isOpen })
    const { command, setCommand, postInsertarUbicacion, loading, disableForm, cerrarPanel, mensaje, status, estados } = UsePanelUbicacionCrear(props)

    const onChangeCombo = (
        event: React.FormEvent<IComboBox>,
        option?: IComboBoxOption,
        nombre?: string
    ) => {
        if (event !== undefined) {
            if (option) {
                switch (nombre) {
                    case "ubicacion":
                        setCommand({
                            ...command,
                            parentId: option.key.toString(),
                        });
                        break;
                    case "nivel":
                        setCommand({
                            ...command,
                            nivel: Number(option.key),
                        });
                        break;
                    default:
                        break;
                }
            }
        }
    };

    const obtenerTextoEncabezado = (nivel?: number, descripcion?: string) => {
        switch (nivel) {
            case 1:
                return "Tajo";
            case 2:
                return "Región";
            case 3:
                return "Ubicación";
            default:
                return descripcion === "ubicacion" ? "Ubicación" : "";
        }
    };

    const onRenderHeader = useCallback(
        () => {
            const headerText = obtenerTextoEncabezado(props.nivel, props.descripcion);
            return (
                <PanelHeader
                    textHeader={`Agregar ${headerText}`}
                />
            );
        },
        [props.nivel, props.descripcion]

    );
    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Guardar"
                    texto2={"Salir"}

                    onClick={postInsertarUbicacion}
                    disableButton={disableForm}
                    onDismiss={() => {
                        cerrarPanel()
                    }}
                />
            </>
        ),
        [command]
    );
    return (
        <Panel
            isOpen={props.isOpen}
            onDismiss={cerrarPanel}
            onRenderFooter={onRenderFooter}
            isFooterAtBottom
            onRenderHeader={onRenderHeader}
        >
            <div className="ms-Grid" dir="ltr">
                <div hidden={mensaje == ""}>
                    <MessageBarResponse
                        objetoResponse={{ codigo: status, mensaje: mensaje }}
                        close={true}
                    />
                </div>
                <div hidden={!loading}>
                    <ProgressBarLoading></ProgressBarLoading>
                </div>
                <div className="ms-Grid-row" hidden={loading}>
                    {!mensaje && (
                        <>
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <TextField
                                    type="text"
                                    label={`Nombre de  ${obtenerTextoEncabezado(props.nivel)}`}
                                    placeholder="Ingrese Nombre"
                                    autoComplete="off"
                                    value={command.nombre}
                                    onChange={(event, newValue) => {
                                        if (newValue != null) {
                                            setCommand({ ...command, nombre: newValue })
                                        }
                                    }}
                                />
                            </div>
                            {/* <div className="ms-Grid-row" hidden={loading}> */}
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <TextField
                                    type="text"
                                    label={`Código de  ${obtenerTextoEncabezado(props.nivel)}`}
                                    placeholder="Ingrese Código"
                                    autoComplete="off"
                                    value={command.codigo}
                                    onChange={(event, newValue) => {
                                        if (newValue != null) {
                                            setCommand({ ...command, codigo: newValue })
                                        }
                                    }}
                                />
                            </div>
                            {/* </div> */}
                            {/* <div className="ms-Grid-row" hidden={loading || props.comboDescripcion == ""}> */}
                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                <ComboBoxIDS
                                    hidden={loading || props.comboDescripcion == ""}
                                    title={`${props.comboDescripcion}`}
                                    componentRef={comboBoxRefUbicacion}
                                    KeyUp={_onkeyUpSearchUbicacion}
                                    onClick={onClickComboUbicacion}
                                    options={dataComboUbicacion}
                                    onChange={(e, option) => {
                                        onChangeCombo(e, option, "ubicacion");
                                    }}
                                />
                            </div>
                            {/* </div> */}
                        </>
                    )}
                </div>
                {/* </div> */}
                {/* <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                        <ComboBoxIDS
                            title="Nivel:"
                            componentRef={comboBoxRefNivel}
                            // KeyUp={_onkeyUpSearch}
                            onClick={onClickComboNivel}
                            options={dataComboNivel}
                            onChange={(e, option) => {
                                onChangeCombo(e, option, "nivel");
                            }}
                        />
                    </div>
                </div> */}
            </div>
        </Panel>
    )
}

export { PanelUbicacionCrear }